export const DEMO_THANK_YOU_PAGE_URL = '/demo/thank-you/';
export const CONTACT_US_THANK_YOU_PAGE_URL = '/company/thank-you/';
